<template>
  <div id="newLink" style="min-height: calc(100% - 160px);min-width: 900px;position: relative;background-color: white;">
      <el-breadcrumb separator="/" >
        <el-breadcrumb-item>监控中心</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/UrlMonitor' }">单链接监控</el-breadcrumb-item>
        <el-breadcrumb-item>新增</el-breadcrumb-item>
      </el-breadcrumb>
    <div class="page">
      <h3 style="padding-bottom: 10px;font-weight: 400;margin-left: 44px;">
        设置监控链接
      </h3>
      <el-row>
        <el-col :span="22" :offset="2">
          <p class="addmonitor">
            <i class="el-icon-warning-outline" style="padding: 0 5px;"></i>
            暂时仅支持淘宝网商品链接，链接越多，验证链接时间越长
          </p>
        </el-col>
        <el-col :span="2">
          <div style="margin-top: 14px;margin-right: 10px;text-align: right;">
            <span style="color: red;padding-right: 5px;">*</span>
            <span>链接地址</span>
          </div>
        </el-col>
        <el-col :span="22">
          <span v-for="(item,i) of items" style="width: 400px;">
            <el-input v-model="items[i].itemlink" placeholder="请输入链接地址" style="width: 400px;margin-top: 10px;" size="small"></el-input>
            -
            <el-input v-model="items[i].itemprice" placeholder="请输入限价" style="width: 120px;" size="small"></el-input>
            <el-button type="text" @click="del(i)" icon="el-icon-circle-close" style="margin-left: 10px;"></el-button>
            <br>
          </span>
        </el-col>
        <el-col :span="22" :offset="2" style="margin-top: 10px;margin-bottom: 10px;" id="onadd">
          <el-button @click="onAdd" style="width: 535px;" icon="el-icon-plus" size="small">新增</el-button>
        </el-col>
        <el-col :span="22" :offset="2">
          <el-button @click="validation" size="small">验证链接</el-button>
        </el-col>
        <el-col :span="22" :offset="2" style="margin-top: 20px;">
          <el-button @click="saveData" type="primary" :disabled="linkDisabled" size="small">确 定</el-button>
          <el-button @click="cancel" type="TheCustom" size="small">取 消</el-button>
        </el-col>
      </el-row>
    </div>

  </div>
</template>

<script>
  import axios from 'axios'
  import {fetchGet, fetchPost} from "@/libs/reqCommon";
  export default {
    data() {
      return {
        items: [{
          itemlink: '',
          itemprice: '',
        }],
        itemlink: [],
        CheckData: [],
        allData: [],
        platform: '',
        linkDisabled: true,
      }
    },
    mounted() {

    },
    methods: {
      //取消
      cancel() {
        this.$router.push({
          path: '/UrlMonitor',
        })
      },
      //新增链接
      saveData() {
        axios({
          method: 'post',
          url: '/hcm/monitorLink/Create',
          headers: {
            'Content-type': 'application/json;charset=UTF-8'
          },
          data: this.allData
        })
        .then((response) => {
          console.log(response.data.status);
          console.log(response);
            if (response.data.status == 10000) {
              this.linkDisabled = false
              this.$router.push({
                path: '/UrlMonitor',
              })
            } else {
              this.$message({
                showClose: true,
                message: response.data.message,
                type: 'error'
              });
              this.linkDisabled = false
            }
          })
        .catch((error) => {
          console.log(error);
        })
      },
      //动态input
      onAdd() {
        this.items.push({
          itemlink: '',
          itemprice: '',
        })
      },
      //链接验证
      validation() {
        console.log(this.items)
        for (var i = 0; i < this.items.length; i++) {
          if (this.items[i].itemlink.indexOf('https://item') != -1 || this.items[i].itemlink.indexOf('https://detail') != -1 || this.items[i].itemlink.indexOf('https://chaoshi.detail') != -1) {
            if (this.items[i].itemprice != '') {
              if (i+1 == this.items.length) {
                this.validationCheck();
              }
            } else {
              var a = i+1
              this.$message.error('请填写正确的第' + a + '条价格');
              return;
            }
          } else {
            console.log(i)
            var b = i+1
            this.$message.error('请填写正确的第' + b + '条链接地址');
            return;
          }
        }
      },
      //链接上传
      validationCheck() {
        this.itemlink = [];
        for (var i = 0; i < this.items.length; i++) {
          var str2 = this.items[i].itemlink.substring(this.items[i].itemlink.indexOf("id=")+3);
          if (str2.substring(0,12).indexOf('&') != -1) {
            this.itemlink.push(str2.substring(0,11))
          } else {
            this.itemlink.push(str2.substring(0,12))
          }
        }
        var nary = this.itemlink;
        for(var i = 0; i < this.itemlink.length - 1; i++) {
          if(nary[i] == this.itemlink[i + 1]) {
            this.$message.error('链接地址重复');
            return;
          }
        }
        let params={
          itemIds: this.itemlink.join(','),
        }
        fetch({
          url: "hcm/monitorLink/check",
          method: "post",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.CheckData = JSON.parse(data)
            this.$message({
              message: '所有链接验证通过',
              type: 'success'
            });
            this.linkDisabled = false
            this.allData = []
            console.log(this.CheckData)
            for (var i = 0; i < this.CheckData.data.length; i++) {
              if (this.items[i].itemlink.indexOf("tmall") != -1) {
                this.platform = '天猫'
              } else {
                this.platform = '淘宝'
              }
              this.allData.push({
                itemid:this.CheckData.data[i].itemId,
                itemlink:this.items[i].itemlink,
                itemprice:this.items[i].itemprice,
                itemtitle:this.CheckData.data[i].itemTitle,
                platform:this.platform,
                shopname:this.CheckData.data[i].shopName,
                shopnick:this.CheckData.data[i].WangWang,
                status: '上架',
              })
            }
            console.log(this.allData)
          }
        })
      },
      //删除
      del(index) {
        if (this.items.length == 1) {
          this.$message({
            showClose: true,
            message: '最少保留一条链接',
            type: 'error'
          });
        } else {
          this.items.splice(index, 1);
        }
      },
    }
  }
</script>
<style scoped lang="scss">
  .header {
    width: 100%;
    height: 40px;
    background-color: white;
  }
  .page {
    padding: 20px;
    margin: 20px;
    background-color: white;
  }

  .addmonitor {
    width: 400px;
    height: 28px;
    flex-shrink: 0;
    padding: 5px 2px;
    display: flex;
    font-size: 12px;
    align-items: center;
    color: #faad14;
    background: rgba(250,173,20,.1);
    margin-bottom: 10px;
  }
  .el-button--TheCustom {
    color: #666;
    border-color: #D9D9D9;
    background-color: #fff;
  }
  .el-button--TheCustom:hover  {
    color: #666;
    border-color: #ded2b8;
    background-color: #faf9f5;
  }

</style>
<style lang="scss">
#newLink {
  #onadd {
    .el-button {
      border: 1px dashed #DCDFE6 !important;
    }
  }
  .el-button--primary {
    color: #FFF;
    background-color: #bda571;
    border-color: #bda571;
  }
  .el-button--primary:hover {
    color: #FFF;
    background-color: #c0ae8a;
    border-color: #c0ae8a;
  }
}
</style>
